const campaignSuggestionTypes = ['campanha_inativos', 'campanha_capturados', 'campanha_aumentar_vendas'];

export function suggestionReviewPath(type, result) {
  if (result?.reviewPath) {
    return result.reviewPath;
  }

  if (!campaignSuggestionTypes.includes(type)) {
    return null;
  }

  const campaignId = Array.isArray(result?.ids) ? result.ids[0] : result?.id;

  return typeof campaignId === 'string' && campaignId.trim()
    ? `/campanha?edit=${encodeURIComponent(campaignId)}`
    : '/campanha';
}
